import React from "react";

const linkStyle = { fontSize: 11.5, color: "rgba(255, 255, 255, 0.7)", letterSpacing: '0.02em' };
const dotStyle = { color: "rgba(255, 255, 255, 0.7)", fontSize: 11 };

/**
 * Global legal footer. Visible on the landing page and the secondary
 * marketing pages (/pricing, /about, /faq, /contact).
 *
 * H40l: the original two-line footer (links + © year) is kept on top so
 * the existing trust signals don't move. A second muted paragraph below
 * carries the full company disclosure required by:
 *   • UK Companies Act 2006 s.82 (company name / number / registered office
 *     on websites operated by limited companies)
 *   • UK GDPR / DPA 2018 (ICO registration number)
 *   • Patent marking (UK Patents Act 1977 s.62) — published application
 *     number rather than a granted patent, so we say "Application".
 *
 * The text is fixed English by design — these are statutory disclosures
 * and the official Worthify Ltd record (Companies House) is English-only.
 * Translating them risks the localised version being read as the
 * authoritative statement.
 */
export const LegalFooter = ({ t }) => (
  <footer
    className="relative z-10 px-4 pb-6 pt-2 text-center"
    data-testid="legal-footer"
  >
    {/* Row 1 — links + © (unchanged from H40k) */}
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5">
      <a href="/terms" className="font-semibold hover:opacity-100 transition-opacity" style={linkStyle} data-testid="footer-link-terms">
        {t('legalNavTerms') || 'Terms of Service'}
      </a>
      <span style={dotStyle}>·</span>
      <a href="/privacy" className="font-semibold hover:opacity-100 transition-opacity" style={linkStyle} data-testid="footer-link-privacy">
        {t('legalNavPrivacy') || 'Privacy Policy'}
      </a>
      <span style={dotStyle}>·</span>
      <a href="/cookies" className="font-semibold hover:opacity-100 transition-opacity" style={linkStyle} data-testid="footer-link-cookies">
        {t('legalNavCookies') || 'Cookie Policy'}
      </a>
      <span style={dotStyle}>·</span>
      <a href="/accessibility" className="font-semibold hover:opacity-100 transition-opacity" style={linkStyle} data-testid="footer-link-accessibility">
        {t('legalNavAccessibility') || 'Accessibility'}
      </a>
      <span style={dotStyle}>·</span>
      <span style={{ fontSize: 11.5, color: "rgba(255, 255, 255, 0.7)" }}>
        © {new Date().getFullYear()} Worthify
      </span>
    </div>

    {/* Row 2 — statutory disclosure (H40l) */}
    <p
      className="mx-auto mt-3 leading-relaxed"
      style={{
        fontSize: 10.5,
        color: "rgba(255, 255, 255, 0.7)",
        maxWidth: 760,
        letterSpacing: '0.01em',
      }}
      data-testid="footer-legal-disclosure"
    >
      Worthify is a trading name of Worthify Ltd. Registered in Scotland,
      company number SC892241. Registered office: Unit 08, Flexspace,
      Glasgow Business Park, Springhill Parkway, Baillieston, Glasgow,
      G69 6GA, United Kingdom. ICO registration C1956536. Protected by
      UK Patent Application GB2613261.3. © {new Date().getFullYear()} Worthify Ltd.
      All rights reserved.
    </p>
  </footer>
);
